import React, { useState } from "react";
import styles from "./TextInput.module.css";

const TextInput = ({ inputType, value, onChange, required=false, error, fadeIn, readOnly=false, customClass="" }) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  //restrict users from putting extra commas in address fields
  const handleKeyDown = (e) => {
    const restrictedCommaFields = ["street1", "street2", "city", "state", "zip_code", "country", "sender", "recipient"];
    if (restrictedCommaFields.includes(inputType) && e.key === ",") { e.preventDefault(); }
  };

  const togglePasswordVisibility = () => setIsPasswordVisible(!isPasswordVisible);

  const placeholders = {
    username: "Username or email",
    new_username: "Enter a username",
    new_email: "Enter email",
    new_address: "Enter new address",
    password: "Password",
    new_password: "Enter a password",
    confirm_password: "Confirm password",
    logistics_provider_code: "Enter logistics provider code",
    business_name: "Business name",
    company_name: "Company name (optional)",
    shopify_store_name: "Ecommerce store name",
    create_link_search_orders: "Enter order #",
    generated_link: "",
    tracking_number: "Enter tracking #",
    street1: "Street address",
    street2: "Alternate street (optional)",
    city: "City",
    state: "State",
    zip_code: "Zip code",
    country: "Country",
    sender: "Sender",
    recipient: "Recipient",
    length: "Length",
    width: "Width",
    height: "Height",
    pounds: "Lbs",
    ounces: "Oz",
    reference_number: "Reference number",
  };

  const placeholder = placeholders[inputType];
  let inputClass = "";
  if (inputType === "create_link_search_orders") { inputClass = styles.create_link_search_orders; } 
  else if (inputType === "tracking_number") { inputClass = styles.tracking_number; }

  return (
    <div className={`${styles.input_container} ${inputClass}`}>
      <input
        type={["length", "width", "height", "pounds", "ounces"].includes(inputType) ? "number" : inputType.includes("password") && !isPasswordVisible ? "password" : "text"}
        placeholder={placeholder}
        className={`${styles.rounded_input} ${customClass} ${isFocused ? styles.focused : ""} ${error ? styles.error_field : ""} ${fadeIn ? "fade_in" : ""} ${inputType === "generated_link" ? styles.generated_link : ""}`}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        value={value ?? ""}
        onChange={readOnly ? undefined : onChange}  // Disable onChange if read-only
        onKeyDown={handleKeyDown}
        required={required}
        autoComplete="off"
        readOnly={readOnly}  // Make input read-only when this prop is true
      />
      {inputType.includes("password") && !readOnly && (<img className={styles.password_toggle} src={`${process.env.PUBLIC_URL}/images/${isPasswordVisible ? "open_eye" : "closed_eye"}.png`} alt={isPasswordVisible ? "Hide password" : "Show password"} onClick={togglePasswordVisibility} />)} {/* Show password toggle only if not read-only*/}
    </div>
  );
};

export default TextInput;
